var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGambia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_440)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.95434 31.0457 3.05176e-05 20 3.05176e-05C8.9543 3.05176e-05 0 8.95434 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 0C11.7317 0 4.63574 5.01766 1.58972 12.1739H38.4104C35.3644 5.01766 28.2684 0 20 0Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 40C28.2684 40 35.3644 34.9823 38.4103 27.8261H1.58972C4.63574 34.9823 11.7317 40 20 40Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.311 14.7826H0.688984C0.240625 16.4461 0 18.1948 0 20C0 21.8052 0.240625 23.5539 0.688984 25.2174H39.3111C39.7594 23.5539 40 21.8052 40 20C40 18.1948 39.7594 16.4461 39.311 14.7826V14.7826Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_440"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGambia);
export default __webpack_public_path__ + "static/media/gambia.bbc221ed662d4606035fe6d9855085fb.svg";
export { ForwardRef as ReactComponent };